import React from 'react'
import { RouteConstants } from '../../../setup/routeConstants'
import { ACCESS_SELLERS_LIST } from '../../../auth/policies'
import { getFeatureFlags } from '../../../setup/configuration'
import NotFoundScreen from '../../../components/ErrorScreen/NotFound'
import LazyProtectedRoute from '../../LazyProtectedRoute'

const SellersComponent = React.lazy(() => import('../../../components/Partners/Sellers'))

// Feature flags are populated at runtime, so the flag is read on render rather than when routes are built.
export function FlaggedSellersPage() {
  return getFeatureFlags()?.EnableSellersListMenu ? <SellersComponent /> : <NotFoundScreen />
}

export default {
  path: RouteConstants.partners.sellers.index.path,
  element: (
    <LazyProtectedRoute
      requiredPolicies={[ACCESS_SELLERS_LIST]}
      component={<FlaggedSellersPage />}
    />
  ),
}
